/**
 * Currently the only shared AttributeAlertLevel among all Alert type
 */
export enum AttributeAlertLevelEnum {
  none = 'none',
}
